export var LockScreenLabels;
(function (LockScreenLabels) {
    LockScreenLabels["SWITCH_USER_LINK"] = "Switch User";
    LockScreenLabels["UNLOCK_BUTTON"] = "Unlock";
    LockScreenLabels["LOCKED"] = "Locked";
})(LockScreenLabels || (LockScreenLabels = {}));
//# sourceMappingURL=LockScreenLabels.js.map